export class DocumentPaths {
    static privacyPolicy = 'privacy-policy';
    static eula = 'eula';
}
